import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-configure-google-calendar',
  templateUrl: './configure-google-calendar.component.html',
  styleUrls: ['./configure-google-calendar.component.scss']
})
export class ConfigureGoogleCalendarComponent {
  formData = {
    clientId: '',
    clientSecret: '',
    redirectUri: ''
  };

  constructor(
    private dialogRef: MatDialogRef<ConfigureGoogleCalendarComponent>
  ) {}

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    if (this.formData.clientId && this.formData.clientSecret) {
      console.log('Saved Configuration:', this.formData);
      this.dialogRef.close(this.formData); 
    } else {
      console.warn('Please fill required fields');
    }
  }
}
